

































import {
  Vue, Component, Prop
} from "@/shared/vuepack";
import { HsabExpenseResponse } from "@/shared/types";
import { formatMMddyyyyDateString } from "@/shared/dateString";
import { reimbursement } from "@/shared/api/expenseService";
import Widget from "@/shared/components/Widget.vue";

@Component({
  components: { Widget },
})
export default class HsabExpenseCardRowInformationRequest extends Vue {
  formatMMddyyyyDateString = formatMMddyyyyDateString;
  @Prop({ required: true })
  expense: HsabExpenseResponse;

  get hasInformationRequests (): boolean {
    return this.expense
        && this.expense.reimbursement
        && this.expense.reimbursement.informationRequests
        && this.expense.reimbursement.informationRequests.length > 0;
  }
}
